'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getClosestTransformedParent;
function getClosestTransformedParent(el) {
    do {
        var style = window.getComputedStyle(el);
        if (style.transform !== 'none' || style.webkitTransform !== 'none') return el;
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-sticky-el/lib/helpers/getClosestTransformedParent.js
// module id = 1988
// module chunks = 0